import AttendancePage from "../features/attendance/AttendancePage";

export default function AttendancePageWrapper() {
  return <AttendancePage />;
}
